import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=a0bdab06&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=a0bdab06&prod&lang=scss&"
import style1 from "./Show.vue?vue&type=style&index=1&id=a0bdab06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bdab06",
  null
  
)

export default component.exports